<template>
  <div>
    <show-top-one></show-top-one>
    <show-top-two></show-top-two>
    <show-top-three></show-top-three>
  </div>
</template>
<script>
import showTopImg from './showTop/showTopImg.vue'
import showTopOne from './showTop/showTopOne.vue'
import showTopTwo from './showTop/showTopTwo.vue'
import showTopThree from './showTop/showTopThree.vue'
export default {
  components: { showTopImg, showTopOne, showTopTwo, showTopThree }
}
</script>
